export default "__VITE_ASSET__vU_ZA$mY__"